import { Col, FormInstance, Row } from "antd";
import { CustomerInputSearch } from "../../../../../../../../components/CustomerInputSearch";
import { useCallback, useMemo } from "react";

type CustomerInputProps = {
  id: string | null | undefined;
  type: 1 | 2;
  isSaving: boolean;
  form: FormInstance;
  setCustomerId: React.Dispatch<React.SetStateAction<string | undefined>>;
};

export const CustomerInput = ({
  id,
  type,
  isSaving,
  form,
  setCustomerId,
}: CustomerInputProps) => {
  const isCustomerDisabled: boolean = useMemo(() => {
    return !id ? type === 2 || isSaving : true;
  }, [id, type, isSaving]);

  const onSuccess = useCallback(
    (val: any) => {
      setCustomerId(val.id);
    },
    [setCustomerId],
  );

  return (
    <Row className="w-100">
      <Col span={10}>
        <CustomerInputSearch
          form={form}
          label="Customer"
          name="customerNumber"
          isFormDisabled={isCustomerDisabled}
          idItemName="customerId"
          onSuccess={onSuccess}
        />
      </Col>
    </Row>
  );
};
